import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import avatar from '../../assets/images/avatar.png';
import photoShine from '../../assets/images/avatar_shadow.png';

const StyledWrapper = styled.div`
	position: relative;
	height: 122px;
`;

const StyledContainer = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 70px 1fr auto 81px auto;
	align-items: center;
	width: calc(100% - 80px);
	height: 121px;
	margin: 0 40px;
	padding-bottom: 1px;
	background-color: rgba(0, 0, 0, 0.02);
	border-bottom: 2px solid rgba(255, 255, 255, 0.1);

	& > * {
		min-width: 0;
	}
`;

const StyledLogoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledDivider = styled.div`
	width: 1px;
	height: 100%;
	background-color: #ffffff;
	opacity: 0.1;
`;

const StyledXPContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	margin-right: 2px;
	padding: 0 10px;
	background-color: #ffb500;
	border-radius: 5px;
	box-shadow: 0px 4px 18px rgba(255, 181, 0, 0.3);

	${Text} {
		color: #000000;
		white-space: nowrap;
	}

	img {
		filter: invert(1);
		user-select: none;
		pointer-events: none;
	}
`;

const StyledUserInfoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
`;

const StyledUserImage = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 34px;
	height: 34px;
	border-radius: 3px;
	user-select: none;
	pointer-events: none;
	background-image: url(${avatar});
	background-size: cover;
	z-index: 1;
`;

const StyledUserImageContainer = styled.div`
	position: relative;
	width: 40px;
	height: 40px;
	border: 1px solid rgba(255, 255, 255, 0.25);
	border-radius: 5px;
`;

const StyledPhotoShine = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 60px;
	height: 60px;
	mask-image: url(${photoShine});
	mask-repeat: no-repeat;
	mask-position: center;
	mask-size: contain;
	-webkit-mask-image: url(${photoShine});
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
	-webkit-mask-size: contain;

	&.top {
		transform: translate(calc(-50% - 10px), calc(-50% - 10px));
	}

	&.bottom {
		transform: translate(calc(-50% + 10px), calc(-50% + 10px));
	}
`;

const StyledButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledReportButtonContainer = styled.div<{ $active: boolean }>`
	position: relative;
	cursor: pointer;
	margin-right: 50px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		opacity: ${({ $active }) => ($active ? 1 : 0.5)};
		margin-top: 35px;
		transition: opacity 0.3s ease;
	}

	.dot {
		position: absolute;
		top: 19px;
		left: 50%;
		transform: translateX(-50%);
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #ff3d3d;
		box-shadow: 0px 2px 10px #ff3d3d;
		opacity: ${({ $active }) => ($active ? 1 : 0)};
		transition: opacity 0.3s ease;
	}

	.line {
		position: absolute;
		bottom: 0;
		left: -10px;
		width: 40px;
		height: 2px;
		background-color: #ffffff;
		opacity: 0;
		transition: opacity 0.3s ease;
	}

	&:hover {
		img {
			opacity: 1;
		}

		.line {
			opacity: 1;
		}
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 16px;
		height: 16px;
	}
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export {
	StyledButtonContent,
	StyledButtonsContainer,
	StyledContainer,
	StyledDivider,
	StyledLogoContainer,
	StyledPhotoShine,
	StyledReportButtonContainer,
	StyledRightContainer,
	StyledUserImage,
	StyledUserImageContainer,
	StyledUserInfoContainer,
	StyledWrapper,
	StyledXPContainer,
};
